import type { NotificationChannel, NotificationPreference, NotificationType } from '@taler/api-client'

const CHANNEL_ORDER: readonly NotificationChannel[] = ['IN_APP', 'EMAIL']

export interface PreferenceRow {
  readonly type: NotificationType
  readonly cells: Partial<Record<NotificationChannel, NotificationPreference>>
}

/** Groups the resolved (type, channel) pairs into one row per type, in the order the API returns them. */
export function groupByType(preferences: readonly NotificationPreference[]): readonly PreferenceRow[] {
  const rows: PreferenceRow[] = []
  const rowByType = new Map<NotificationType, PreferenceRow>()
  for (const preference of preferences) {
    let row = rowByType.get(preference.type)
    if (row === undefined) {
      row = { type: preference.type, cells: {} }
      rowByType.set(preference.type, row)
      rows.push(row)
    }
    row.cells[preference.channel] = preference
  }
  return rows
}

/** Column headers: only channels that appear in at least one legal pairing, in a fixed order. */
export function channelColumns(
  preferences: readonly NotificationPreference[],
): readonly NotificationChannel[] {
  const present = new Set(preferences.map((preference) => preference.channel))
  return CHANNEL_ORDER.filter((channel) => present.has(channel))
}
